import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@bugpilot/plugin-nextjs/dist/client/Bugpilot.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@bugpilot/plugin-nextjs/dist/client/WidgetTrigger.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/pages/explore.tsx")